import { useState } from "react";
import { useForm } from "react-hook-form";
import {
  ProdutoConsultaDto,
  ProdutoConsultaSchema,
  ProdutoNFCeDto,
} from "../../../NFCe/NFCe.Dto";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  ExtrairConsultaProdutoComando,
  MapearErrosServidor,
} from "src/hook/Functions";
import { ProdutoFiltrar } from "src/services/Estoque.Service";
import { NFeCadastroItemLoad } from "./NFe.Cadastro.Item.Load";
import { showToast } from "src/componentes";
import { useDelayedLoading } from "src/hook/useDelayedLoading";
import { useNavigate } from "react-router-dom";

export const NFeCadastroItemCode = () => {
  const navigate = useNavigate();

  const { loading, start, stop } = useDelayedLoading(2000);
  const [dataProdutoConsulta, setDataProdutoConsulta] = useState<
    ProdutoNFCeDto[]
  >([]);
  const [modalShowConsultaProduto, setModalShowConsultaProduto] =
    useState(false);
  const [descricaoProdutoConsulta, setDescricaoProdutoConsulta] = useState("");
  const nfeItensLoad = NFeCadastroItemLoad();
  const [modalShowPropriedades, setModalShowPropriedades] = useState(false);
  const [produtoPropriedades, setProdutoPropriedades] =
    useState<ProdutoNFCeDto>();

  const formProdutoConsulta = useForm<ProdutoConsultaDto>({
    resolver: yupResolver(ProdutoConsultaSchema),
  });

  const onSubmitProdutoConsulta = async (data: ProdutoConsultaDto) => {
    start();

    const comando = ExtrairConsultaProdutoComando(data.nome);
    if (comando) {
      data.nome = comando.codigoProduto;
    }

    const response = await ProdutoFiltrar(data);
    if (response.data.success) {
      const data = response.data.data;

      data.forEach((item: ProdutoNFCeDto) => {
        item.valorUnitarioComercial =
          comando?.valor ?? item.valorUnitarioComercial;
        item.valorUnitarioTributavel = item.valorUnitarioComercial;
        item.quantidadeComercial = comando?.quantidade ?? 1;
        item.quantidadeTributavel = comando?.quantidade ?? 1;

        item.codigoBarrasTributavel = item.codigoBarras;
        item.unidadeTributavel = item.unidadeComercial;
        item.quantidadeTributavel = item.quantidadeComercial;

        item.indicaTotal = 1;
      });

      if (data.length === 0) {
        formProdutoConsulta.setError(
          "nome",
          { message: "Não localizado" },
          { shouldFocus: true }
        );
      } else if (data.length === 1) {
        setDescricaoProdutoConsulta(data[0].nome);
        const produtoNFCe = data[0] as ProdutoNFCeDto;
        nfeItensLoad.setDataProdutoNFe((prevData) => [
          ...prevData,
          produtoNFCe,
        ]);
      } else {
        setDataProdutoConsulta(data);
        setModalShowConsultaProduto(true);
      }
    } else {
      MapearErrosServidor(response.data.notifications, showToast);
    }
    stop();
  };

  const onHideModalConsultaProduto = () => {
    setModalShowConsultaProduto(false);
  };

  const onSelectModalConsultaProduto = (value: ProdutoNFCeDto) => {
    onHideModalConsultaProduto();
    formProdutoConsulta.setFocus("nome", { shouldSelect: true });
    setDescricaoProdutoConsulta(value.nome);
    nfeItensLoad.setDataProdutoNFe((prevData) => [...prevData, value]);
  };

  const onCancelModalPropriedades = () => {
    setModalShowPropriedades(false);
  };

  const onDeleteModalPropriedades = (value: ProdutoNFCeDto) => {
    if (nfeItensLoad.dataProdutoNFe.length === 1) {
      nfeItensLoad.setDataProdutoNFe([]);
    } else {
      nfeItensLoad.setDataProdutoNFe((prev) =>
        prev.filter((item) => item !== value)
      );
    }
  };

  const handleClickPropriedades = (value: ProdutoNFCeDto) => () => {
    setModalShowPropriedades(true);
    setProdutoPropriedades(value);
  };

  const possuiItens = () => {
    return nfeItensLoad.dataProdutoNFe.length > 0;
  };

  const totalNFe = () => {
    const total = nfeItensLoad.dataProdutoNFe.reduce(
      (acc, item) =>
        acc + item.valorUnitarioComercial * item.quantidadeComercial,
      0
    );
    return total;
  };
  const handleVoltar = () => () => {
    navigate("../destinooperacao");
  };

  const handleProximo = () => {
    navigate("../pagamento");
  };

  return {
    loading,
    descricaoProdutoConsulta,
    formProdutoConsulta,
    onSubmitProdutoConsulta,
    onHideModalConsultaProduto,
    modalShowConsultaProduto,
    dataProdutoConsulta,
    nfeItensLoad,
    onSelectModalConsultaProduto,
    modalShowPropriedades,
    setModalShowPropriedades,
    produtoPropriedades,
    onCancelModalPropriedades,
    onDeleteModalPropriedades,
    handleClickPropriedades,
    possuiItens,
    totalNFe,
    handleVoltar,
    handleProximo,
  };
};
